import { ActionCreator, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";
import { isEmpty } from "lodash";

import {
  AuthNotificationsDownloadActionDispatchTypes,
  GetReferralAuthHistoryActionDispatchTypes,
  GetReferralListActionDispatchTypes,
  GetReferralSearchListActionDispatchTypes,
  NtuReasonMasterActionDispatchTypes,
  PostAuthNotificationsActionDispatchTypes,
  PostNtuPatientActionDispatchTypes,
} from "../constants/HomePage";
import toastType from "../utils/SnackbarProvider";
import {
  GetBlobByIdDownload,
  GetDinaLaunchUrl,
  GetDisciplineStatusList,
  GetDocumentDownload,
  GetDownloadDocumentOfNotification,
  GetIsRetroDetails,
  GetMasterNtuReason,
  GetNotificationsList,
  GetPhysicianDetails,
  GetReAuthDefaultServiceProvider,
  GetReAuthReferralData,
  GetReferralAuthHistory,
  GetReferralListByProviderId,
  GetReferralListBySearchTerm,
  GetSlots,
  PostDocumentReview,
  PostIngestProcessSubmit,
  PostNtuPatient,
  PostPriorAuthSubmit,
  PostReAuthAuthSubmit,
  PostReferralDocumentReview,
  PostViewedNotificationDetails,
  PostUpdateStartOfCareDate,
  UploadDocumentsFile,
  GetMaxAllowedSocDate,
  PostAuthNotifications,
  GetAuthNotificationsDownload,
} from "../services/Referral";
import {
  AuthorizationPayload,
  DocumentReviewPayload,
  MaxAllowedSocDatePayload,
  NtuPatientPayload,
  ReAuthRequestPayload,
  ReferralDetailsPayload,
  ReferralSearchPayload,
  SlotsPayload,
  UpdateStartOfCareDatePayload,
  ViewedNotificationDetails,
} from "../models/Referral";
import { configUrl } from "../constants/Config";
import {
  AuthNotificationsDispatchTypes,
  AuthNotificationsDownloadDispatchTypes,
  DocumentDownloadDispatchTypes,
  DocumentReviewDispatchTypes,
  DocumentUploadDispatchTypes,
  DownloadDocumentOfNotificationDispatchTypes,
  GetDisciplineStatusListDispatchTypes,
  GetIsRetroDetailsDispatchTypes,
  GetNotificationsListDispatchTypes,
  GetPhysicianDetailsDispatchTypes,
  IngestProcessDispatchTypes,
  MaxAllowedSocDateDispatchTypes,
  NtuPatientDispatchTypes,
  NtuReasonMasterDispatchTypes,
  PostPriorAuthSubmitDispatchTypes,
  PostReAuthRequestActionDispatchTypes,
  ReAuthDefaultReferralDataActionDispatchTypes,
  ReAuthDefaultServiceProviderActionDispatchTypes,
  ReferralAuthHistoryDispatchTypes,
  ReferralListDispatchTypes,
  ReferralManagementDispatchTypes,
  ReferralSearchListDispatchTypes,
  SlotsActionDispatchTypes,
  UpdateNotificationViewListDispatchTypes,
  UpdateStartOfCareDateDispatchTypes,
} from "../models/dispatchTypes/Referral";
import { ApplicationState } from "../redux/ApplicationState";
import { MessageType, ResponseMessages } from "../constants/ResponseMessage";
import {
  IngestProcessActionDispatchTypes,
  PostPriorAuthSubmitActionDispatchTypes,
  PostReAuthRequestDispatchTypes,
  ReAuthDefaultReferralDataDispatchTypes,
  ReAuthDefaultServiceProviderDispatchTypes,
  ReferralDocumentFileDispatchTypes,
  SlotsDispatchTypes,
  ReferralManagementActionDispatchTypes,
  DocumentReviewActionDispatchTypes,
  DocumentDownloadActionDispatchTypes,
  GetPhysicianDetailsActionDispatchTypes,
  GetDisciplineStatusListActionDispatchTypes,
  GetIsRetroDetailsActionDispatchTypes,
  GetNotificationsListActionDispatchTypes,
  UpdateNotificationViewListActionDispatchTypes,
  DownloadDocumentOfNotificationActionDispatchTypes,
  Numbers,
  UpdateStartOfCareDateActionDispatchTypes,
  MaxAllowedSocDateActionDispatchTypes,
} from "../constants/Referral";

export const getReferralListByProviderId: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ReferralListDispatchTypes
  >
> = (payload: ReferralDetailsPayload) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: GetReferralListActionDispatchTypes.GET_REFERRAL_LIST_INVOKE,
    });
    const response = await GetReferralListByProviderId(configUrl, payload);
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          typeof response.data === "string" && toastType.error(response.data);
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: GetReferralListActionDispatchTypes.GET_REFERRAL_LIST_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getReferralSearchList: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ReferralSearchListDispatchTypes
  >
> = (payload: ReferralSearchPayload) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: GetReferralSearchListActionDispatchTypes.GET_REFERRAL_SEARCH_LIST_INVOKE,
    });
    const response = await GetReferralListBySearchTerm(configUrl, payload);
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          typeof response.data === "string" && toastType.error(response.data);
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: GetReferralSearchListActionDispatchTypes.GET_REFERRAL_SEARCH_LIST_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getReferralAuthHistory: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ReferralAuthHistoryDispatchTypes
  >
> = (referralId: number) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: GetReferralAuthHistoryActionDispatchTypes.GET_REFERRAL_AUTH_HISTORY_INVOKE,
    });
    const response = await GetReferralAuthHistory(configUrl, referralId);
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: GetReferralAuthHistoryActionDispatchTypes.GET_REFERRAL_AUTH_HISTORY_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const postNtuPatient: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    NtuPatientDispatchTypes
  >
> = (payload: NtuPatientPayload) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: PostNtuPatientActionDispatchTypes.POST_NTU_PATIENT_INVOKE,
    });
    const response = await PostNtuPatient(configUrl, payload);
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          dispatch({
            error: response,
            type: PostNtuPatientActionDispatchTypes.POST_NTU_PATIENT_ERROR,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: PostNtuPatientActionDispatchTypes.POST_NTU_PATIENT_SUCCESS,
          });
          toastType.success(ResponseMessages(MessageType.SAVE_NTU_PATIENT));
          break;
        default:
          break;
      }
    }
  };
};

export const getMasterNtuReason: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    NtuReasonMasterDispatchTypes
  >
> = (typeId: boolean) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: NtuReasonMasterActionDispatchTypes.GET_NTU_REASON_INVOKE,
    });
    const response = await GetMasterNtuReason(configUrl, typeId);
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: NtuReasonMasterActionDispatchTypes.GET_NTU_REASON_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: NtuReasonMasterActionDispatchTypes.GET_NTU_REASON_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const postPriorAuthSubmit: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    PostPriorAuthSubmitDispatchTypes
  >
> = (payload: AuthorizationPayload) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: PostPriorAuthSubmitActionDispatchTypes.POST_PRIOR_AUTH_SUBMIT_INVOKE,
    });
    const response = await PostPriorAuthSubmit(configUrl, payload);
    if (isEmpty(response)) {
      toastType.error(ResponseMessages(MessageType.REFERRAL_NOT_CREATED));
      dispatch({
        error: ResponseMessages(MessageType.REFERRAL_NOT_CREATED),
        type: PostPriorAuthSubmitActionDispatchTypes.POST_PRIOR_AUTH_SUBMIT_ERRORS,
      });
    }
    if (response && response.status) {
      switch (response.status) {
        case 400:
          dispatch({
            error: response.data ?? ResponseMessages(MessageType.REFERRAL_NOT_CREATED),
            type: PostPriorAuthSubmitActionDispatchTypes.POST_PRIOR_AUTH_SUBMIT_ERRORS,
          });
          break;
        case 422:
        case 500:
        case 404:
          dispatch({
            error: ResponseMessages(MessageType.REFERRAL_NOT_CREATED),
            type: PostPriorAuthSubmitActionDispatchTypes.POST_PRIOR_AUTH_SUBMIT_ERRORS,
          });
          break;
        case 200:
        case 201:
          toastType.success(ResponseMessages(MessageType.REFERRAL_CREATED));
          dispatch({
            response: response.data,
            type: PostPriorAuthSubmitActionDispatchTypes.POST_PRIOR_AUTH_SUBMIT_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const postReAuthSubmit: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    PostReAuthRequestActionDispatchTypes
  >
> = (payload: ReAuthRequestPayload) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: PostReAuthRequestDispatchTypes.POST_RE_AUTH_REQUEST_INVOKE,
    });
    const response = await PostReAuthAuthSubmit(configUrl, payload);
    if (isEmpty(response)) {
      toastType.error(ResponseMessages(MessageType.REFERRAL_NOT_CREATED));
      dispatch({
            error: ResponseMessages(MessageType.REFERRAL_NOT_CREATED),
            type: PostReAuthRequestDispatchTypes.POST_RE_AUTH_REQUEST_ERRORS,
      });
    } 
    if (response && response.status) {
      switch (response.status) {
        case 400:
          dispatch({
            error: response.data ?? ResponseMessages(MessageType.REFERRAL_NOT_CREATED),
            type: PostReAuthRequestDispatchTypes.POST_RE_AUTH_REQUEST_ERRORS,
          });
          break;
        case 422:
        case 500:
        case 404:
          dispatch({
            error: ResponseMessages(MessageType.REFERRAL_NOT_CREATED),
            type: PostReAuthRequestDispatchTypes.POST_RE_AUTH_REQUEST_ERRORS,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: PostReAuthRequestDispatchTypes.POST_RE_AUTH_REQUEST_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};
export const uploadDocumentFile: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    DocumentUploadDispatchTypes
  >
> = (payload: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ReferralDocumentFileDispatchTypes.REFERRAL_DOCUMENT_INVOKE,
    });
    const response = await UploadDocumentsFile(configUrl, payload);

    if (isEmpty(response)) {
      toastType.warning(ResponseMessages(MessageType.DOCUMENT_NOT_UPLOADED));
      dispatch({
        error: ResponseMessages(MessageType.DOCUMENT_NOT_UPLOADED),
        type: ReferralDocumentFileDispatchTypes.REFERRAL_DOCUMENT_ERRORS,
      });
      return;
    }

    if (response && response.status) {
      switch (response.status) {
        case 500:
        case 422:
        case 400:
        case 504:
          toastType.warning(
            ResponseMessages(MessageType.DOCUMENT_NOT_UPLOADED)
          );
          dispatch({
            response,
            error: ResponseMessages(MessageType.DOCUMENT_NOT_UPLOADED),
            type: ReferralDocumentFileDispatchTypes.REFERRAL_DOCUMENT_ERRORS,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: ReferralDocumentFileDispatchTypes.REFERRAL_DOCUMENT_SUCCESS,
          });
          if (response.data?.status === "Failed") {
            toastType.error(response.data?.responseMessage);
          }
          break;
        default:
          break;
      }
    }
  };
};

export const getSlots: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    SlotsActionDispatchTypes
  >
> = (payload: SlotsPayload) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: SlotsDispatchTypes.SLOTS_INVOKE,
    });
    const response = await GetSlots(configUrl, payload);
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: SlotsDispatchTypes.SLOTS_ERRORS,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: SlotsDispatchTypes.SLOTS_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const postUpdateStartOfCareDate: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    UpdateStartOfCareDateDispatchTypes
  >
> = (payload: UpdateStartOfCareDatePayload) => {
  const startOfCareUpdateErrorMessage = ResponseMessages(MessageType.START_OF_CARE_UPDATE_FAILED);
  const startOfCareUpdateSuccessMessage = ResponseMessages(MessageType.START_OF_CARE_UPDATE_SUCCESS);

  return async (dispatch: Dispatch) => {
    dispatch({
      type: UpdateStartOfCareDateActionDispatchTypes.UPDATE_START_OF_CARE_DATE_INVOKE,
    });

    const response = await PostUpdateStartOfCareDate(configUrl, payload);

    if (isEmpty(response)) {
      toastType.error(startOfCareUpdateErrorMessage);
      dispatch({
        error: startOfCareUpdateErrorMessage,
        type: UpdateStartOfCareDateActionDispatchTypes.UPDATE_START_OF_CARE_DATE_ERROR,
      });
      return;
    }

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 500:
        case 404:
        case 400:
          if (isEmpty(response.data) || typeof response.data !== "object") {
            toastType.error(startOfCareUpdateErrorMessage);
          } else {
            Object.values(response.data).flat().forEach((message) => {
              typeof message === "string" && toastType.error(message);
            });
          }
          dispatch({
            error: response.data ?? startOfCareUpdateErrorMessage,
            type: UpdateStartOfCareDateActionDispatchTypes.UPDATE_START_OF_CARE_DATE_ERROR,
          });
          break;
        case 200:
        case 201:
          toastType.success(startOfCareUpdateSuccessMessage);
          dispatch({
            response: response.data,
            type: UpdateStartOfCareDateActionDispatchTypes.UPDATE_START_OF_CARE_DATE_SUCCESS,
          });
          break;
        default:
          toastType.error(startOfCareUpdateErrorMessage);
          dispatch({
            error: startOfCareUpdateErrorMessage,
            type: UpdateStartOfCareDateActionDispatchTypes.UPDATE_START_OF_CARE_DATE_ERROR,
          });
          break;
      }
    }
  };
};

export const getReAuthReferralData: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ReAuthDefaultReferralDataActionDispatchTypes
  >
> = (referralId: number) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ReAuthDefaultReferralDataDispatchTypes.RE_AUTH_DEFAULT_REFERRAL_DATA_INVOKE,
    });
    const response = await GetReAuthReferralData(configUrl, referralId);
    dispatch({
      response: response.data,
      type: ReAuthDefaultReferralDataDispatchTypes.RE_AUTH_DEFAULT_REFERRAL_DATA_SUCCESS,
    });
  };
};

export const getReAuthDefaultServiceProvider: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ReAuthDefaultServiceProviderActionDispatchTypes
  >
> = (providerId: number) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ReAuthDefaultServiceProviderDispatchTypes.RE_AUTH_DEFAULT_SERVICE_PROVIDER_INVOKE,
    });
    const response = await GetReAuthDefaultServiceProvider(
      configUrl,
      providerId
    );
    dispatch({
      response: response.data,
      type: ReAuthDefaultServiceProviderDispatchTypes.RE_AUTH_DEFAULT_SERVICE_PROVIDER_SUCCESS,
    });
  };
};

export const ingestProcess: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    IngestProcessDispatchTypes
  >
> = (payload: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: IngestProcessActionDispatchTypes.INGEST_PROCESS_INVOKE,
    });
    const response = await PostIngestProcessSubmit(configUrl, payload);
    if (isEmpty(response)) {
      dispatch({
            error: ResponseMessages(MessageType.INGEST_PROCESS_FAILED),
            type: IngestProcessActionDispatchTypes.INGEST_PROCESS_ERRORS,
      });
    } 
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 500:
        case 400:
          dispatch({
            response,
            error: ResponseMessages(MessageType.INGEST_PROCESS_FAILED),
            type: IngestProcessActionDispatchTypes.INGEST_PROCESS_ERRORS,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: IngestProcessActionDispatchTypes.INGEST_PROCESS_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getDinaLaunchUrl: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ReferralManagementDispatchTypes
  >
> = (email: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ReferralManagementActionDispatchTypes.GET_REFERRAL_MANAGEMENT_INVOKE,
    });
    const response = await GetDinaLaunchUrl(configUrl, email);

    dispatch({
      response: response.data,
      type: ReferralManagementActionDispatchTypes.GET_REFERRAL_MANAGEMENT_SUCCESS,
    });
  };
};

export const postDocumentReview: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    DocumentReviewDispatchTypes
  >
> = (payload: DocumentReviewPayload , type? : number) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: DocumentReviewActionDispatchTypes.DOCUMENT_REVIEW_INVOKE,
    });
    const response = type === Numbers.TWO ? await PostReferralDocumentReview(configUrl, payload) : await PostDocumentReview(configUrl, payload);
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          dispatch({
            error: response,
            type: DocumentReviewActionDispatchTypes.DOCUMENT_REVIEW_ERROR,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: DocumentReviewActionDispatchTypes.DOCUMENT_REVIEW_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const documentDownload: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    DocumentDownloadDispatchTypes>
> = (blobId: number, type?: number) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: DocumentDownloadActionDispatchTypes.DOCUMENT_DOWNLOAD_INVOKE,
    });

    const response = type === Numbers.TWO ? await GetBlobByIdDownload(configUrl, blobId, "file") : await GetDocumentDownload(configUrl, blobId, "file");

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          dispatch({
            response,
            type: DocumentDownloadActionDispatchTypes.DOCUMENT_DOWNLOAD_ERROR,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: {
              blob: response.data,
              headers: response.headers,
            },
            type: DocumentDownloadActionDispatchTypes.DOCUMENT_DOWNLOAD_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

  export const getPhysicianDetails: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    GetPhysicianDetailsDispatchTypes>
> = (referralId: number) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: GetPhysicianDetailsActionDispatchTypes.GET_PHYSICIAN_DETAILS_INVOKE,
    });

    const response = await GetPhysicianDetails(
      configUrl,
      referralId
    );

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          dispatch({
            error: response,
            type: GetPhysicianDetailsActionDispatchTypes.GET_PHYSICIAN_DETAILS_ERROR,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: GetPhysicianDetailsActionDispatchTypes.GET_PHYSICIAN_DETAILS_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
 };

export const getDisciplineStatusList: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    GetDisciplineStatusListDispatchTypes>
> = (referralId: number) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: GetDisciplineStatusListActionDispatchTypes.GET_DISCIPLINE_STATUS_LIST_INVOKE,
    });

    const response = await GetDisciplineStatusList(
      configUrl,
      referralId
    );

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          dispatch({
            error: response,
            type: GetDisciplineStatusListActionDispatchTypes.GET_DISCIPLINE_STATUS_LIST_ERROR,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: GetDisciplineStatusListActionDispatchTypes.GET_DISCIPLINE_STATUS_LIST_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getIsRetroDetails: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    GetIsRetroDetailsDispatchTypes>
> = (startOfCareDate: string, userSpecificReceivedDateTime: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: GetIsRetroDetailsActionDispatchTypes.GET_IS_RETRO_DETAILS_INVOKE,
    });

    const response = await GetIsRetroDetails( configUrl, startOfCareDate, userSpecificReceivedDateTime );

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          dispatch({
            error: response,
            type: GetIsRetroDetailsActionDispatchTypes.GET_IS_RETRO_DETAILS_ERROR,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: GetIsRetroDetailsActionDispatchTypes.GET_IS_RETRO_DETAILS_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getNotificationsList: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    GetNotificationsListDispatchTypes>
> = (userId: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: GetNotificationsListActionDispatchTypes.GET_NOTIFICATIONS_LIST_INVOKE,
    });

    const response = await GetNotificationsList(configUrl, userId);

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          dispatch({
            error: response,
            type: GetNotificationsListActionDispatchTypes.GET_NOTIFICATIONS_LIST_ERROR,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: GetNotificationsListActionDispatchTypes.GET_NOTIFICATIONS_LIST_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const postViewedNotificationDetails: ActionCreator<
ThunkAction<
  void,
  ApplicationState,
  Record<string, never>,
  UpdateNotificationViewListDispatchTypes
>
> = (payload: ViewedNotificationDetails) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: UpdateNotificationViewListActionDispatchTypes.UPDATE_NOTIFICATION_VIEW_LIST_INVOKE,
    });
    const response = await PostViewedNotificationDetails(configUrl, payload);
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          dispatch({
            error: response.data,
            response: null,
            type: UpdateNotificationViewListActionDispatchTypes.UPDATE_NOTIFICATION_VIEW_LIST_ERROR,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: UpdateNotificationViewListActionDispatchTypes.UPDATE_NOTIFICATION_VIEW_LIST_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const downloadDocumentOfNotification: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    DownloadDocumentOfNotificationDispatchTypes>
> = (blobId: number) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: DownloadDocumentOfNotificationActionDispatchTypes.DOWNLOAD_DOCUMENT_OF_NOTIFICATION_INVOKE,
    });

    const response = await GetDownloadDocumentOfNotification(
      configUrl,
      blobId,
      "file",
      (percent: number) => {
        dispatch({
          type: DownloadDocumentOfNotificationActionDispatchTypes.DOWNLOAD_DOCUMENT_OF_NOTIFICATION_PROGRESS,
          progress: percent,
        });
      }
    );

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          dispatch({
            response,
            type: DownloadDocumentOfNotificationActionDispatchTypes.DOWNLOAD_DOCUMENT_OF_NOTIFICATION_ERROR,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: {
              blob: response.data,
              headers: response.headers,
            },
            type: DownloadDocumentOfNotificationActionDispatchTypes.DOWNLOAD_DOCUMENT_OF_NOTIFICATION_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getMaxAllowedSocDate: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    MaxAllowedSocDateDispatchTypes
  >
> = (payload: MaxAllowedSocDatePayload) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: MaxAllowedSocDateActionDispatchTypes.GET_MAX_ALLOWED_SOC_DATE_INVOKE,
    });
    const response = await GetMaxAllowedSocDate( configUrl, payload );
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          dispatch({
            response,
            type: MaxAllowedSocDateActionDispatchTypes.GET_MAX_ALLOWED_SOC_DATE_ERROR,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: MaxAllowedSocDateActionDispatchTypes.GET_MAX_ALLOWED_SOC_DATE_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const postAuthNotifications: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    AuthNotificationsDispatchTypes
  >
> = (referralId: number) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: PostAuthNotificationsActionDispatchTypes.POST_AUTH_NOTIFICATIONS_INVOKE,
    });
    const response = await PostAuthNotifications(
      configUrl,
      referralId
    );
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          dispatch({
            error: response,
            type: PostAuthNotificationsActionDispatchTypes.POST_AUTH_NOTIFICATIONS_ERROR,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: PostAuthNotificationsActionDispatchTypes.POST_AUTH_NOTIFICATIONS_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getAuthNotificationsDownload: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    AuthNotificationsDownloadDispatchTypes
  >
> = (blobId: number) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: AuthNotificationsDownloadActionDispatchTypes.GET_AUTH_NOTIFICATIONS_DOWNLOAD_INVOKE,
    });
    const response = await GetAuthNotificationsDownload(
      configUrl,
      blobId,
    );
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          dispatch({
            error: response,
            type: AuthNotificationsDownloadActionDispatchTypes.GET_AUTH_NOTIFICATIONS_DOWNLOAD_ERROR,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: {
              blob: response.data,
              headers: response.headers,
            },
            type: AuthNotificationsDownloadActionDispatchTypes.GET_AUTH_NOTIFICATIONS_DOWNLOAD_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};